var e="@hpstellar/core/tabs",a={label:"Tabs",IOSPlaceholder:"-- select an option --"};export{a as tabsListTranslations,e as tabsTestId};
